import { Database, FolderPlus, Plus } from '@ondit/ui/icons'
import { type ChromeActionSpec, ResourceChromeFallback } from '@/screens/workspace/components'
import { FOLDERED_RESOURCE_HEADERS } from '@/screens/workspace/components/folders/foldered-resources'
import { useT } from '~/core/i18n'

const KNOWLEDGE_HEADER = FOLDERED_RESOURCE_HEADERS.knowledge_base

const COLUMNS = [
  { id: 'name', header: 'Name' },
  { id: 'documents', header: 'Documents', widthMultiplier: 0.6 },
  { id: 'tokens', header: 'Tokens', widthMultiplier: 0.6 },
  { id: 'created', header: 'Created' },
  { id: 'owner', header: 'Owner' },
  { id: 'updated', header: 'Last Updated' },
]

const ACTIONS = [
  { text: 'New folder', icon: FolderPlus },
  { text: 'New base', icon: Plus, variant: 'primary' },
] satisfies ChromeActionSpec[]

export default function KnowledgeLoading() {
  const t = useT()
  return (
    <ResourceChromeFallback
      icon={Database}
      title={KNOWLEDGE_HEADER.rootLabel}
      columns={COLUMNS.map((column) => ({ ...column, header: t(column.header) }))}
      actions={ACTIONS.map((action) => ({ ...action, text: t(action.text) }))}
      searchPlaceholder={t('Search knowledge bases...')}
      hasSort
      hasFilter
    />
  )
}
